// RankridgeFAQTease.jsx
import React, { useState } from "react";

const BRAND = "#20b2aa"; // Rankridge teal

const FAQS = [
  {
    q: "Why is Rankridge considered the Best IIT-JEE & NEET Coaching Institute in Hyderabad?",
    a: [
      "Rankridge has become a symbol of trust for engineering and medical aspirants because of our consistent track record of producing top ranks in IIT-JEE Mains, IIT-JEE Advanced, and NEET.",
      "Our strengths include:",
      "• IIT/NIT/AIIMS alumni faculty with proven mentoring expertise",
      "• Customized study plans based on student learning pace",
      "• Regular mock tests & performance analytics",
      "• Stress-free, motivating learning environment",
      "This is why parents confidently choose Rankridge as the best coaching for IIT-JEE and NEET.",
    ],
  },
  {
    q: "How is Rankridge different from other IIT-JEE and NEET coaching institutes?",
    a: [
      "While many institutes teach, we transform.",
      "At Rankridge, we believe every student is unique, so we follow the Rankridge Personal Mentoring System:",
      "• Small batches for personal attention",
      "• Doubt-solving within 24 hours",
      "• Weekly improvement meetings with faculty & mentors",
      "• Motivational sessions to keep energy high year-round",
      "Here, your child won’t get lost in the crowd — they will shine.",
    ],
  },
  {
    q: "How does Rankridge balance Board Exam Preparation with IIT-JEE & NEET Coaching?",
    a: [
      "Our Integrated Curriculum ensures students excel in both:",
      "• We cover NCERT syllabus thoroughly for Board exams",
      "• Parallel coaching ensures IIT-JEE/NEET topics are mastered",
      "• Extra board-focused revision modules before exams",
      "• Time management training so students handle both exams with confidence",
      "With Rankridge, students score 90%+ in Boards while preparing for India’s toughest competitive exams.",
    ],
  },
  {
    q: "What is Rankridge’s track record of success?",
    a: [
      "Rankridge students have secured:",
      "• Top 100 ranks in IIT-JEE Advanced",
      "• NEET scores of 680+ for multiple students",
      "• Admissions in IIT Bombay, IIT Madras, AIIMS Delhi, JIPMER, NITs",
      "• 95%+ of our batches consistently get placed in top engineering & medical colleges",
      "Our alumni are now doctors, engineers, and innovators shaping the future.",
    ],
  },
  {
    q: "What facilities and learning resources does Rankridge provide?",
    a: [
      "• State-of-the-art smart classrooms",
      "• Dedicated Physics, Chemistry, and Biology labs",
      "• Digital learning support for online & offline revisions",
      "• Rankridge Exclusive Study Material updated every year",
      "• Air-conditioned, student-friendly campus for comfortable learning",
      "Everything is designed to keep students focused, comfortable, and inspired.",
    ],
  },
  {
    q: "How does Rankridge keep students motivated for long-term courses?",
    a: [
      "• Monthly Motivation Seminars by toppers & alumni",
      "• Peer Learning Groups for healthy competition",
      "• Reward programs for improvement",
      "• Personal counselling for emotional well-being",
      "We believe a happy mind learns faster — so we combine academic rigor with a positive environment.",
    ],
  },
  {
    q: "How can parents track their child’s progress?",
    a: [
      "We treat parents as partners in success:",
      "• Monthly performance reports sent directly to parents",
      "• WhatsApp updates on attendance & achievements",
      "• PTMs (Parent-Teacher Meetings) every quarter",
      "• Instant alerts for any drop in performance",
      "Parents always know exactly where their child stands.",
    ],
  },
  {
    q: "What makes Rankridge’s faculty the best in Hyderabad?",
    a: [
      "Our teachers are IIT/NIT/AIIMS graduates who:",
      "• Have cracked competitive exams themselves",
      "• Bring years of real teaching experience",
      "• Provide practical tips and exam strategies",
      "• Focus on concept clarity & application skills",
      "They are more than teachers — they are mentors for life.",
    ],
  },
  {
    q: "How does Rankridge prepare students in the final months before exams?",
    a: [
      "We run an Exam Acceleration Program:",
      "• Daily mock tests simulating the real exam",
      "• Chapter-wise rapid revisions",
      "• Rank-booster question banks",
      "• Exam temperament training to stay calm under pressure",
      "By exam day, our students are battle-ready.",
    ],
  },
  {
    q: "Does Rankridge provide online support for IIT-JEE & NEET students?",
    a: [
      "Yes ✅",
      "• Live online classes with doubt resolution",
      "• Recorded lectures for anytime revision",
      "• Online test series with instant results",
      "• Digital doubt-solving platform so no question goes unanswered",
      "Whether offline or online, Rankridge ensures uninterrupted learning.",
    ],
  },
];

// helpers
const toPlainText = (arrOrStr) => {
  const str = Array.isArray(arrOrStr) ? arrOrStr.join(" ") : arrOrStr;
  return str.replace(/•\s?/g, "").replace(/\s+/g, " ").trim();
};

const teaser = (a, n = 140) => {
  const text = toPlainText(a);
  if (text.length <= n) return text;
  // cut at nearest space for a clean tease
  const cut = text.lastIndexOf(" ", n);
  return text.slice(0, cut > 80 ? cut : n) + "…";
};

export default function RankridgeFAQTease() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-10">
        <h2 className="text-2xl sm:text-2xl font-extrabold text-center">
          Rankridge IIT-JEE & NEET — <span style={{ color: BRAND }}>FAQs</span>
        </h2>
        

        <div className="mt-8 space-y-4">
          {FAQS.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={item.q}
                className="rounded-2xl border border-gray-100 bg-gray-50/60 hover:bg-white transition-shadow shadow-sm hover:shadow-md"
              >
                {/* Question row */}
                <button
                  className="w-full text-left px-5 sm:px-6 py-4 flex items-start justify-between gap-4"
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                >
                  <div className="flex-1">
                    <h3 className="text-lg sm:text-xl font-semibold leading-snug">{item.q}</h3>
                    {/* Teaser line visible when collapsed */}
                    {!isOpen && (
                      <p className="mt-1 text-gray-600">
                        {teaser(item.a, 160)}
                      </p>
                    )}
                  </div>
                  <span
                    className={`mt-1 inline-flex h-7 w-7 items-center justify-center rounded-full border text-sm transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    style={{ borderColor: BRAND, color: BRAND }}
                    aria-hidden
                  >
                    ▼
                  </span>
                </button>

                {/* Answer panel */}
                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 sm:px-6 pb-5 text-gray-700 leading-relaxed">
                      {Array.isArray(item.a) ? (
                        <div className="space-y-2">
                          {item.a.map((line, i) =>
                            line.startsWith("•") ? (
                              <ul key={i} className="list-disc list-inside">
                                <li>{line.replace(/^•\s?/, "")}</li>
                              </ul>
                            ) : (
                              <p key={i}>{line}</p>
                            )
                          )}
                        </div>
                      ) : (
                        <p>{item.a}</p>
                      )}

                      {/* Hide link inside expanded panel */}
                      <div className="mt-3">
                        <button
                          onClick={() => setOpenIdx(null)}
                          className="text-sm font-medium"
                          style={{ color: BRAND }}
                        >
                          Hide ▲
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
